export const FormSamplesFormOnlyFieldsPageInfo = () => {
    return (
        <>
            Some fields are only used on the form, in this example the confirm password is only used
            in this form component, but not needed anywhere else in the application. So the confirm password field is:
            <ul>
                <li>defined only in the interface for this form.</li>
                <li>exluded on submit. (Done on the FormItem component for confirm password).</li>
            </ul>
            Fill in the form, click on submit and look at the outcome to see the confirmPassword field is not submitted.
        </>
    )
}
